import { FiFileText, FiGift, FiGrid, FiImage, FiPackage, FiTag } from "react-icons/fi";

const categoryIcons = {
  all: FiGrid,
  vestuario: FiPackage,
  papelaria: FiFileText,
  brindes: FiGift,
  sinalizacao: FiImage,
  package: FiPackage,
  file: FiFileText,
  gift: FiGift,
  image: FiImage,
  tag: FiTag,
};

const StoreCategoryMenu = ({ categories, selectedCategory, onSelect }) => {
  return (
    <section className="store-category-menu">
      <div className="store-category-list">
        {categories.map((category) => {
          const isActive = selectedCategory === category.id;
          const Icon = categoryIcons[category.icon] || categoryIcons[category.id] || FiTag;

          return (
            <button
              key={category.id}
              type="button"
              className={`store-category-chip ${isActive ? "active" : ""}`}
              onClick={() => onSelect(category.id)}
            >
              <Icon />
              <span>{category.label}</span>
            </button>
          );
        })}
      </div>
    </section>
  );
};

export default StoreCategoryMenu;
